// extracted by mini-css-extract-plugin
module.exports = {"Host":"TaskDetails_Host_3SctX","Title":"TaskDetails_Title_17XSI","History":"TaskDetails_History_bdGWO","Button":"TaskDetails_Button_2EyI1"};